<template>
  <div class="row">
    <div class="col-md-6">
      <listado-ventas
        :key="componentKeyListadoVentas"
        :user-id="userId"
        :token-auth="tokenAuth"
        @sale-selected="handleSaleSelected"
        @sales-updated="handleSalesUpdated"
      />
    </div>
    <div class="col-md-6">
      <div
        class="card"
        style="
          margin-bottom: 10px;
          background-color: #ffffff99;
          box-shadow: 0 4px 10px -2px rgba(0, 0, 0, 0.5) !important;
        "
      >
        <div class="card-body" style="background-color: transparent">
          <div class="row">
            <div class="col-12">
              <p
                style="
                  margin: 0 10px 10px 10px;
                  font-family: Ubuntu;
                  font-size: 14px;
                  font-weight: 900;
                  color: #7d0c7e;
                "
              >
                Mapa de Ventas Instaladas
              </p>
            </div>
          </div>
          <div class="map-container" style="height: 500px; width: 100%">
            <div
              id="sales-map"
              ref="mapContainer"
              style="height: 100%; width: 100%"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import ListadoVentas from "./ListadoVentas.vue";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

export default {
  components: {
    ListadoVentas,
  },
  props: [],
  data() {
    let data = this.$store.state.user;
    return {
      componentKeyListadoVentas: 400,
      userId: data.userId,
      role: data.role,
      tokenAuth: this.$store.state.tokenAuth,
      map: null,
      salesMarkers: [],
      salesData: [],
      selectedSale: null,
      markerIcon: null,
      selectedMarkerIcon: null,
      mapInitialized: false,
      resizeObserver: null,
      reiniciarListadoVentasHandler: null,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.reiniciarListadoVentasHandler = () => {
      this.componentKeyListadoVentas += 1;
    };

    this.$eventBus.on(
      "reiniciarListadoVentas",
      this.reiniciarListadoVentasHandler,
    );

    // Initialize map icons
    this.initIcons();

    // Use setTimeout to ensure the DOM is fully rendered
    setTimeout(() => {
      this.initMap();
      this.fetchSalesData();

      // Setup resize observer for map container
      this.setupResizeObserver();
    }, 300);

    // Add resize event listener
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    // Clean up map when component is destroyed
    if (this.map) {
      this.map.remove();
      this.map = null;
      this.mapInitialized = false;
    }

    // Disconnect resize observer
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    // Remove event listeners with the stored function reference
    if (this.reiniciarListadoVentasHandler) {
      this.$eventBus.off(
        "reiniciarListadoVentas",
        this.reiniciarListadoVentasHandler,
      );
    }

    window.removeEventListener("resize", this.handleResize);

    // Clear markers
    this.clearMarkers();
  },
  methods: {
    // Setup ResizeObserver to detect container size changes
    setupResizeObserver() {
      if (this.$refs.mapContainer && typeof ResizeObserver !== "undefined") {
        this.resizeObserver = new ResizeObserver((entries) => {
          if (this.map && this.mapInitialized) {
            this.map.invalidateSize();
          }
        });
        this.resizeObserver.observe(this.$refs.mapContainer);
      }
    },

    // Handle window resize
    handleResize() {
      if (this.map && this.mapInitialized) {
        this.map.invalidateSize();
      }
    },
    refresh() {
      this.$eventBus.emit("reiniciarListadoVentas");
      // The map will be updated when ListadoVentas emits the sales-updated event
    },
    initIcons() {
      // Fix for Leaflet icon paths
      delete L.Icon.Default.prototype._getIconUrl;
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        iconUrl: require("leaflet/dist/images/marker-icon.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
      });

      // Create custom colored icons
      // Using colored markers from MapMarker.io or other sources
      // You can change the color by changing the URL
      this.markerIcon = L.icon({
        iconUrl:
          "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-violet.png",
        shadowUrl:
          "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      });

      this.selectedMarkerIcon = L.icon({
        iconUrl:
          "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
        shadowUrl:
          "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
        iconSize: [30, 45],
        iconAnchor: [15, 45],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      });
    },
    initMap() {
      try {
        // Check if map container exists
        const mapContainer = this.$refs.mapContainer;
        if (!mapContainer) {
          console.error("Map container not found");
          return;
        }

        // Check if map is already initialized
        if (this.map) {
          this.map.remove();
          this.map = null;
        }

        // Initialize map centered on Ecuador
        this.map = L.map("sales-map", {
          center: [-1.8312, -78.1834],
          zoom: 7,
          maxZoom: 19,
          zoomControl: true,
        });

        // Add OpenStreetMap tile layer
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          maxZoom: 19,
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(this.map);

        // Fix for "_latLngToNewLayerPoint" error when zooming
        L.Marker.prototype._animateZoom = function (opt) {
          if (!this._map) {
            return;
          }
          try {
            const pos = this._map
              ._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center)
              .round();
            this._setPos(pos);
          } catch (e) {
            console.warn("Error in marker animation:", e);
          }
        };

        // Fix for popup positioning errors
        L.Popup.prototype._animateZoom = function (opt) {
          if (!this._map) {
            return;
          }
          try {
            const anchor = this._getAnchor();
            const pos = this._map._latLngToNewLayerPoint(
              this._latlng,
              opt.zoom,
              opt.center,
            );
            this._setPosition(pos);
          } catch (e) {
            console.warn("Error in popup animation:", e);
          }
        };

        // Force a map invalidation and redraw
        setTimeout(() => {
          this.map.invalidateSize();
          this.mapInitialized = true;
        }, 100);
      } catch (error) {
        console.error("Error initializing map:", error);
      }
    },
    fetchSalesData() {
      this.$https
        .post("/sales/fetchInstalledSales/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
        })
        .then((response) => {
          this.salesData = response.data.sales;
          if (this.mapInitialized) {
            this.updateMapMarkers();
          } else {
            // If map isn't initialized yet, wait a bit and try again
            setTimeout(() => {
              if (this.map) {
                this.updateMapMarkers();
              }
            }, 500);
          }
        })
        .catch((error) => {
          if (error.status === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error("Sesión expirada. Inicie sesión nuevamente", {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "Signin" });
          } else if (error.status === 404) {
            this.salesData = [];
            this.$toast.success("No se encontraron ventas instaladas", {
              position: "top-right",
              max: 10,
            });
          } else {
            this.$toast.error("Ocurrió un error inesperado", {
              position: "top-right",
              max: 10,
            });
          }
        });
    },
    updateMapMarkers() {
      if (!this.map) {
        console.error("Map not initialized");
        return;
      }

      try {
        // Clear existing markers
        this.clearMarkers();

        // Add markers for each sale with location data
        this.salesData.forEach((sale) => {
          if (
            sale.location &&
            sale.location._latitude &&
            sale.location._longitude
          ) {
            const lat = sale.location._latitude;
            const lng = sale.location._longitude;

            try {
              // Create marker
              const marker = L.marker([lat, lng], { icon: this.markerIcon })
                .addTo(this.map)
                .bindPopup(
                  `<b>${sale.displayName || "Cliente"}</b><br>
                  ${sale.phone || "Sin teléfono"}<br>
                  Estado: ${sale.status || "N/A"}<br>
                  Valor: $${sale.planValue ? Number(sale.planValue).toFixed(2) : "N/A"}`,
                );

              // Add click event to marker
              marker.on("click", () => {
                this.handleMarkerClick(sale, marker);
              });

              // Store marker reference
              this.salesMarkers.push(marker);
            } catch (err) {
              console.error("Error adding marker:", err);
            }
          }
        });

        // If we have markers, fit the map to show all of them
        if (this.salesMarkers.length > 0) {
          try {
            const group = new L.featureGroup(this.salesMarkers);
            this.map.fitBounds(group.getBounds(), { padding: [50, 50] });
          } catch (err) {
            console.error("Error fitting bounds:", err);
            // Fallback to center view
            this.map.setView([-1.8312, -78.1834], 7);
          }
        }
      } catch (error) {
        console.error("Error updating markers:", error);
      }
    },
    handleSaleSelected(sale) {
      this.selectedSale = sale;

      if (!this.map || !this.mapInitialized) {
        console.error("Map not initialized");
        return;
      }

      // Find the corresponding marker
      if (
        sale.location &&
        sale.location._latitude &&
        sale.location._longitude
      ) {
        const selectedMarker = this.salesMarkers.find((marker) => {
          const latLng = marker.getLatLng();
          return (
            latLng.lat === sale.location._latitude &&
            latLng.lng === sale.location._longitude
          );
        });

        if (selectedMarker) {
          try {
            // Update all markers to default icon
            this.salesMarkers.forEach((marker) => {
              marker.setIcon(this.markerIcon);
            });

            // Set selected marker to highlighted icon
            selectedMarker.setIcon(this.selectedMarkerIcon);

            // Open popup and center map on the marker
            selectedMarker.openPopup();
            this.map.setView(selectedMarker.getLatLng(), 15);
          } catch (err) {
            console.error("Error handling selected sale:", err);
          }
        }
      }
    },
    handleMarkerClick(sale, marker) {
      // Update selected sale
      this.selectedSale = sale;

      try {
        // Update all markers to default icon
        this.salesMarkers.forEach((m) => {
          m.setIcon(this.markerIcon);
        });

        // Set clicked marker to highlighted icon
        marker.setIcon(this.selectedMarkerIcon);
      } catch (err) {
        console.error("Error handling marker click:", err);
      }
    },
    // Utility function to safely remove all markers
    clearMarkers() {
      if (!this.map) return;

      // Safely remove each marker
      this.salesMarkers.forEach((marker) => {
        try {
          if (marker && marker._map) {
            marker.removeFrom(this.map);
          }
        } catch (e) {
          console.warn("Error removing marker:", e);
        }
      });

      this.salesMarkers = [];
    },
    handleSalesUpdated(salesData) {
      if (this.mapInitialized) {
        this.salesData = salesData;
        this.updateMapMarkers();
      }
    },
  },
  unmounted() {
    // This is intentionally left empty as all cleanup is now in beforeUnmount
  },
};
</script>

<style lang="scss">
.leaflet-container {
  font-family: Ubuntu, sans-serif;
  z-index: 1;
}

.leaflet-popup-content {
  font-size: 14px;
}

/* Fix for potential z-index issues */
.leaflet-map-pane {
  z-index: 2 !important;
}

.leaflet-google-layer {
  z-index: 1 !important;
}
</style>
